// Module
var code = "<div> <span></span> <input type=\"text\" qp-accept=\"number\" allow-negative=\"false\" allow-decimal=\"true\" decimal-precision=\"2\" ng-model=\"ngModel\" ng-model-options=\"{debounce:1000}\" autocomplete=\"off\"> <span></span> </div>";
// Exports
export default code;